import { useEffect, useRef, type RefObject } from "react";

// Storing onDismiss in a ref (rather than a dependency) keeps the listener
// subscribed only while `open` toggles, matching the app-shell account menu's
// pointerdown idiom without resubscribing on every render.
export function useDismissOnOutsideClick<T extends HTMLElement>(
  open: boolean,
  onDismiss: () => void,
): RefObject<T | null> {
  const containerRef = useRef<T>(null);
  const dismissRef = useRef(onDismiss);
  useEffect(() => {
    dismissRef.current = onDismiss;
  }, [onDismiss]);
  useEffect(() => {
    if (!open) return;
    const closeOnOutsideClick = (event: PointerEvent) => {
      if (!containerRef.current?.contains(event.target as Node))
        dismissRef.current();
    };
    window.addEventListener("pointerdown", closeOnOutsideClick);
    return () => window.removeEventListener("pointerdown", closeOnOutsideClick);
  }, [open]);
  return containerRef;
}
